import { AccountAPI, computed, debug, NetbankingAPI, observable } from "aaa";
import { action } from "mobx";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { ISigningInfo } from "types/signing";
import { AccountAPIClient, NetbankingAPIClient } from "../../network/APIClient";
import authStore from "stores/AuthStore";

export class PocketsStore {
    @observable hasFeature = false;
    @observable alreadyActivated = false;
    @observable signInfo?: ISigningInfo;

    // Needed only for platforms using PdfViewer component for rendering (currently only Android)
    pdfData?: Uint8Array;

    @observable _isLoading = true;

    @computed get isLoading() {
        return this._isLoading;
    }

    @action async loadData() {
        try {
            this._isLoading = true;

            if (externalInterfaceStore.accountId) {
                const accountTarget = NetbankingAPI.getAccount(externalInterfaceStore.accountId);
                const account = (await NetbankingAPIClient.requestType(accountTarget));

                if (!account.flags?.includes("savingEnvelopesConsentRequired") && account.flags?.includes("savingEnvelopesCreationAllowed")) {
                    this.alreadyActivated = true;
                }

                if (account.features?.includes("savingEnvelopes")) {
                    this.hasFeature = true;
                }
            }

            this._isLoading = false;
        } catch (error) {
            debug.log("[PocketsStore] loadData error:", error);

            throw error;
        }
    }

    @action async postPocketsActivation() {
        if (!externalInterfaceStore.accountId) {
            return;
        }

        try {
            this._isLoading = true;

            const response = await AccountAPIClient.requestType(AccountAPI.postPocketsActivation(externalInterfaceStore.accountId));

            this.signInfo = response.signInfo;

            this._isLoading = false;
        } catch (error) {
            this._isLoading = false;
            throw error;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/pockets/PocketsStore.ts